import React from "react";
import { Flex } from "../compositeComponents/FlexHelpers";
import { ISelectionStats, SurveySegment, ScoredSelectionStats, SurveyQuestion } from "../../amorg-common";
import { AggregatedSurveyAnswerScoreRadialChart, SurveyQuestionAnswerScoreRadialChart } from "./SurveyAnswerScoreRadialChart";
import { QuestionSurveyAnswerRatioBar, AggregatedSurveyAnswerRatioBar } from "../../pages/workplaceassessments/[activityId]/_components/tabs/report/_components/SurveyAnswerRatioBar";

type SegmentStatsComparisonGraphProps =  
    {
        type: 'all' | 'indicator' | 'theme'
        data:{
            segments: SurveySegment[],
            stats: ScoredSelectionStats;
        }[]
    }
    |
    {
        type: 'question',
        question:SurveyQuestion;
        data:{
            segments: SurveySegment[],
            stats: ISelectionStats;
        }[]
    };
export function SegmentStatsComparisonGraph (props: SegmentStatsComparisonGraphProps): JSX.Element
{
    return (
        <div style={{ display: 'flex', width: '100%', flexDirection: 'column', gap: '4px' }}>
            {props.data.map((i, index) =>
            {
                return (
                    <Flex key={index} alignItems='center' gap={8}>
                        
                        {props.type === 'question' &&
                            <SurveyQuestionAnswerScoreRadialChart question={props.question} stats={i.stats} />
                        }
                        {props.type !== 'question' &&
                            <AggregatedSurveyAnswerScoreRadialChart stats={i.stats} />
                        }

                        <Flex style={{ flexGrow: 1 }} flexDirection='column' alignItems='flex-start' gap={4}>

                            <span style={{ whiteSpace: 'nowrap', fontSize: '12px', color: '#333' }}>{i.segments.map(s => `${s.value}`).join(' | ')}</span>

                        
                            {props.type === 'question' &&
                                <QuestionSurveyAnswerRatioBar stats={i.stats} question={props.question} />
                            }

                            {props.type !== 'question' &&
                                <AggregatedSurveyAnswerRatioBar stats={i.stats as ScoredSelectionStats} />
                            }

                        </Flex>
                        
                    </Flex>
                );
            })}
        </div>
    );
}